/** Responsive breakpoint identifiers matching body:before values in global-styles.scss */
export enum ScreenSize {
  XS = 'screen-xs',
  SM = 'screen-sm',
  MD = 'screen-md',
  LG = 'screen-lg',
  XL = 'screen-xl',
  XXL = 'screen-2xl',
}